export interface FeaturedImageIC {
  url: string;
  width: number;
  height: number;
  title: string;
}

export interface FeaturedVideoIC {
  url: string;
}

export interface ArticleFeaturedIC {
  featuredVideo: FeaturedVideoIC;
  featuredImage: FeaturedImageIC;
  featuredTitle: string;
  featuredDescription: any;
  expertise: string;
  industry: string;
  services: [];
  slug: string;
  category: string;
}

export interface ArticleFeaturedProps {
  article: ArticleFeaturedIC;
  classIndex?: number;
  sectionLayout?: string;
  hasHoverEffect?: string;
  articleUrl?: string;
  subCategory?: string;
}
export interface ArticleFeaturedMobileProps {
  article: ArticleFeaturedIC;
  classIndex?: number;
  sectionLayout?: string;
  hasHoverEffect?: string;
  articleUrl?: string;
  isTapped: boolean;
}

export interface SectionLayoutVariantsIC {
  [key: string]: string;
}

export interface SectionIC {
  __typename: string;
  sys: { id: string };
  title: string;
  layout: string;
  hasHoverEffect: string;
  sectionPadding: boolean;
  numberOfLoadedContent: number;
  sectionContentCollection: { items: ArticleFeaturedIC[] };
  quoteText?: string;
  author?: string;
  authorTitle?: string;
  borderless?: boolean;
  internalTitle?: string;
  imagesCollection: { items: ImageInterfaces[] };
}

export interface ImageInterfaces {
  url: string[];
  altText: string[];
  description: string[];
}
export interface ArticleSectionIC {
  section: SectionIC;
  subCategory?: string;
}
export interface QuoteSectionIC {
  section: {
    quoteText?: string;
    author?: string;
    authorTitle?: string;
  };
}

export interface SectionRelatedTopicsIC {
  section: {
    title: string;
    topicListCollection: { items: any };
  };
}

export interface CardSectionItem {
  cardImage?: ContentfulImageIC;
  description: any;
  __typename: string;
  shortDescription: string;
  linkUrl: string;
  internalTitle: string;
  title: string;
  linkIconTitle: string;
  linkMailto: string;
  videoUrl: string;
  videoAutoPlay: boolean;
  cardTemplate: string;
}
export interface CSectionIC {
  internalTitle: string;
  title: string;
  slug?: string;
  numberOfLoadedCards: number;
  layout: string;
  sectionPadding: boolean;
  sectionContentCollection: { items: CardSectionItem[] };
}
export interface CardSectionIC {
  section: CSectionIC;
  slug: string;
}

export enum ContactFormTitle {
  CONTACT_FORM = 'Contact form',
  INCYBER_CONTACT_FORM = 'Incyber Contact form'
}

export interface LinkedInIC {
  title: string;
  urlPath: string;
  document: {
    title: string;
    description: string;
    url: string;
    width: number;
    height: number;
  };
}

export interface BannerIC {
  __typename: string;
  title?: string;
  linkedIn?: LinkedInIC;
  personMail: string;
  personName: string;
  personPosition: string;
  pictureOfPerson: ContentfulImageIC;
  picturePosition: string;
  quote: string;
  locations: [];
}

export interface BannerPropsIC {
  data: BannerIC;
  sectionbaner?: boolean;
}
export interface PBSectionIC {
  internalTitle: string;
  layout: string;
  numberOfLoadedContent: number;
  sectionContentCollection: { items: BannerIC[] };
  title: string;
  __typename: string;
}
export interface PersonBannerSectionIC {
  section: PBSectionIC;
}

export interface ContentfulImageIC {
  src?: string;
  width?: number;
  height?: number;
  alt?: string;
  url?: string;
  title?: string;
}
export interface LinkIC {
  title: string;
  urlPath: string;
  document: ContentfulImageIC;
}

export interface AccordionIC {
  title: string;
  description: JSON;
}

export interface NavigationElementIC {
  groupName?: string;
  __typename: string;
  title: string;
  urlPath: string;
}

export interface MenuGroupIC {
  __typename: string;
  internalTitle: string;
  groupName: string;
  secondaryTitle?: string;
  secondaryTitleLink?: string;
  titleForFirstColumn?: string;
  slugForFirstColumn?: string;
  featuredPagesFirstColumnCollection?: { items: NavigationElementIC[] };
  titleForSecondColumn?: string;
  slugForSecondColumn?: string;
  featuredPagesSecondColumnCollection?: { items: NavigationElementIC[] };
  titleForThirdColumn?: string;
  slugForThirdColumn?: string;
  titleForFourthColumn?: string;
  slugForFourthColumn?: string;
  featuredPagesFourthColumnCollection?: { items: NavigationElementIC[] };
  featuredPagesThirdColumnCollection?: { items: NavigationElementIC[] };
  groupLink?: NavigationElementIC;
  containerForCategoryLink: ContainerForCategoryLink;
  sys: {
    id: string;
  };
}

export interface ContainerForCategoryLink {
  internalTitle: string;
  title: string;
  linkUrl: string;
  linkIconTitle: string;
  shortDescription: any;
  icon: Icon;
}

export interface Icon {
  url: string;
  width: number;
  height: number;
  size: number;
  description: string;
}
export interface MenuItemIC {
  closeOtherMenus?: () => void;
  isOpen?: boolean;
  groupItem: MenuGroupIC;
}
export interface MobileMenuItemIC {
  groupItem: MenuGroupIC;
}
export interface SubmenuListIC {
  href?: string;
  groupName?: string;
  slug?: string;
  title?: string;
  items?: {
    urlPath?: string;
    title?: string;
  }[];
  isSubMenuOpen?: boolean;
}

export interface JobItemIC {
  id: string;
  title: string;
  locations: JobLocation[];
  tags?: string[];
  description: string;
  sharing_description: string;
  requirements: string;
  created_at: string;
  slug: string;
  cover_image: any;
  open_questions: OpenQuestion[];
}
export interface JobsIC {
  count: string;
  bannerData: any;
}

export interface JobLocation {
  id: number;
  name: string;
  state: string;
  state_code: string;
  country: string;
  country_code: string;
  city: string;
  postal_code: string;
  note?: string;
  street?: string;
}

export interface ObjectInterface {
  key: string;
  json: string;
}

export interface ContentfulThumbnailVideo {
  src?: string;
  width?: number;
  height?: number;
  alt?: string;
  url?: string;
  title?: string;
}
export interface ContentfulVideoIC {
  width?: number;
  height?: number;
  description?: string;
  url?: string;
  title?: string;
}

export interface SectionCardIC {
  title?: string;
  cardImage?: ContentfulImageIC;
  internalTitle?: string;
  shortDescription?: any;
  linkUrl?: string;
  linkIconTitle?: string;
  linkMailto?: string;
  icon?: ContentfulImageIC;
  setionLayout?: string;
  slug?: string;
  backgroundColor?: string;
  hasBackgroundColor?: boolean;
  onlyImagevideo?: boolean;
  videoThumbnail?: ContentfulThumbnailVideo;
  videoUrl: string;
  videoAutoPlay: boolean;
  cardTemplate: string;
}

export interface CardIC {
  __typename?: string;
  sectionLayout: string;
  classIndex: number;
  slug: string;
  sectionPadding: boolean;
  card: SectionCardIC;
}

export interface CardProps {
  card: SectionCardIC;
  slug: string;
  sectionPadding: boolean;
}

export interface CardTemplateIC {
  card: SectionCardIC;
  slug: string;
  sectionPadding: boolean;
}

export interface OpenQuestion {
  id: number;
  position: number;
  options: Record<string, any>;
  required: boolean;
  body: string;
  kind: string;
  open_question_options: OpenQuestionOption[];
  translations: Translations;
}

interface OpenQuestionOption {
  id: number;
  position: number;
  body: string;
  translations: Translations;
}

interface Translation {
  body: string;
}

interface Translations {
  [languageCode: string]: Translation;
}
